import React from 'react';
import './Arc.css';

class Arc extends React.Component {
    state = {
        start: [this.props.nodes[0].x, this.props.nodes[0].y],
        end: [this.props.nodes[1].x, this.props.nodes[1].y]
    }

    render() {
        const start = [this.props.nodes[0].x, this.props.nodes[0].y];
        const end = [this.props.nodes[1].x, this.props.nodes[1].y];
        const dx = end[0] - start[0];
        const dy = end[1] - start[1];
        let angle = Math.atan(dy/dx) * (180 / Math.PI);
        
        // if angle in rad === -0
        if(Object.is(-0, angle)) {
            angle = -180;
        }

        if(dy > 0 && angle < 0) {
            angle += -180;
        }

        if(dx < 0 && angle > 0) {
            angle += 180;
        }

        // const r = Math.floor(Math.random()*255);  
        // const g = Math.floor(Math.random()*255);
        // const b = Math.floor(Math.random()*255); 

        const style = {
            top: start[1] + 20,
            left: start[0] + 20,
            width: Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)),
            transform: `rotate(${angle}deg)`
        }

        if(this.props.type) {
            style.backgroundColor = 'red';
        }

        return (
            <div className="arc" style={style}>
                <p className="arc-distance" style={{transform: `rotate(${-angle}deg)`}}>{this.props.distance}</p>
            </div>
        );
    }
}

export default Arc;